import { mapGetters, mapState } from "vuex";
import { ATTEMPTABLE_TYPE, NAMESPACE } from "@modules/attempt/service/attempt.constant";
import ROLE from "@/configs/role";
import { isDefined, isEmpty } from "@/utils/var.check";
import { INTEGRATOR_APP_FEATURE_CATEGORY } from "@modules/app/service/app.constant";

export default {
  computed: {
    ...mapState(NAMESPACE.APP, ["integratorAppList"]),
    ...mapState(NAMESPACE.ATTEMPT, ["attemptContext"]),
    ...mapGetters(NAMESPACE.AUTH, ["userDisplayName", "userId"]),
    ...mapGetters(NAMESPACE.ATTEMPT, [
      "isTeacherView",
      "isStudentView",
      "isTeacherStudentView",
      "getTeamByUserIdAndActivityId",
    ]),
    ...mapGetters(NAMESPACE.APP, [
      "isIntegratorAppEnabled",
      "hasIntegratorAppCategoryAccess",
      "getWhitelistDomainMaps",
    ]),
    ...mapGetters(NAMESPACE.RESOURCE, ["isComponentTeamResponse"]),
    ...mapGetters(NAMESPACE.APP, ["isIntegratorAppEnabled", "hasIntegratorAppCategoryAccess"]),
    hasGoogleDriveAccess() {
      return (
        this.isIntegratorAppEnabled(INTEGRATOR_APP_FEATURE_CATEGORY.GOOGLE_DRIVE) &&
        this.hasIntegratorAppCategoryAccess(INTEGRATOR_APP_FEATURE_CATEGORY.GOOGLE_DRIVE)
      );
    },
    // not naming as just academic year as it might clash with other components
    attemptAcademicYear() {
      if (isDefined(this.attemptContext) && isDefined(this.attemptContext.academicYear)) {
        return this.attemptContext.academicYear;
      }
      if (isDefined(this.params) && isDefined(this.params.academicYear)) {
        return this.params.academicYear;
      }
      return 0;
    },
    activityTeam() {
      if (!this.component) {
        return "";
      }
      if (!this.isComponentTeamResponse(this.component.componentId)) {
        return "";
      }

      return this.getTeamByUserIdAndActivityId(Number(this.userId), Number(this.component.pageId));
    },
    activityTeamName() {
      if (!this.activityTeam) {
        return "";
      }
      return this.activityTeam.name;
    },
    activityTeamId() {
      if (!this.activityTeam) {
        return null;
      }
      return this.activityTeam.id;
    },
    resource() {
      return this.$parent?.resource || this.$parent?.$parent?.resource;
    },
  },
  methods: {
    attemptPageId(component) {
      if (isDefined(component) && !isEmpty(component.pageId)) {
        return component.pageId;
      }

      if (!isEmpty(this.$route.params.pageId)) {
        return parseInt(this.$route.params.pageId);
      }
      return "";
    },
  },
  provide() {
    const resource = this.resource || {};
    const component = this.component || {};
    return {
      pageContext: {
        lessonId: resource.id,
        lessonResourceDomain: resource.resourceDomain,
      },
      richTextContext: {
        pageDomain: "attempt",
        viewingRole: this.isTeacherView || this.isTeacherStudentView ? ROLE.TEACHER : ROLE.STUDENT,
        resourceUuid: resource.uuid || "",
        pageId: this.params?.pageId ?? this.attemptPageId(component),
        componentId: component.componentId || "",
        uploadFrom: this.uploadFrom || "",
        lessonId: resource.id,
        lessonTitle: resource.title,
        lessonUuid: this.params?.lessonUuid ?? resource.uuid,
        resourceType: resource.resourceType,
        resourceDomain: resource.resourceDomain,
        hasTtsAccess: this.isTeacherStudentView,
        hasGoogleDriveAccess: this.hasGoogleDriveAccess,
        appList: this.integratorAppList,
        academicYear: this.attemptAcademicYear,
        activityTeamName: this.activityTeamName,
        activityTeamId: this.activityTeamId,
        studentName: this.userDisplayName,
        isTeacherStudentViewOrStudentView: this.isTeacherStudentView || this.isStudentView,
        whitelistDomainMaps: this.getWhitelistDomainMaps,
        attemptContext: this.attemptContext,
        assignmentUuid:
          isDefined(this.attemptContext) &&
          this.attemptContext.attemptableType === ATTEMPTABLE_TYPE.ASSIGNMENT_LESSON
            ? this.attemptContext.attemptableUuid
            : null,
      },
    };
  },
};
